/* tslint:disable */

/**
 * Futures (COIN-M) REST API
 *
 * Access market data, manage accounts, and trade COIN-M perpetual and delivery futures.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PlaceMultipleOrdersBatchOrdersParameterInner
 */
export interface PlaceMultipleOrdersBatchOrdersParameterInner {
    /**
     * Symbol
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    symbol: string;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    side: PlaceMultipleOrdersBatchOrdersParameterInnerSideEnum;
    /**
     * Default `BOTH` for One-way Mode ; `LONG` or `SHORT` for Hedge Mode. It must be sent with Hedge Mode.
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    positionSide?: PlaceMultipleOrdersBatchOrdersParameterInnerPositionSideEnum;
    /**
     * **After CM migration, stop-type values (`STOP`, `STOP_MARKET`, `TAKE_PROFIT`, `TAKE_PROFIT_MARKET`, `TRAILING_STOP_MARKET`) are no longer accepted on a per-element basis and will return element-level `-4120`. Use the new `/dapi/v1/algoOrder` endpoint instead.**
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    type: PlaceMultipleOrdersBatchOrdersParameterInnerTypeEnum;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    timeInForce?: PlaceMultipleOrdersBatchOrdersParameterInnerTimeInForceEnum;
    /**
     * quantity measured by contract number
     * @type {number}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    quantity: number;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    reduceOnly?: PlaceMultipleOrdersBatchOrdersParameterInnerReduceOnlyEnum;
    /**
     * Order price
     * @type {number}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    price?: number;
    /**
     * A unique id among open orders. Automatically generated if not sent. Can only be string following the rule: `^[\\.A-Z\\:/a-z0-9_-]{1,36}$`
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    newClientOrderId?: string;
    /**
     * Used with `STOP/STOP_MARKET` or `TAKE_PROFIT/TAKE_PROFIT_MARKET` orders.
     * @type {number}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    stopPrice?: number;
    /**
     * Used with `TRAILING_STOP_MARKET` orders, default as the latest price(supporting different `workingType`)
     * @type {number}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    activationPrice?: number;
    /**
     * Used with `TRAILING_STOP_MARKET` orders, min 0.1, max 4 where 1 for 1%
     * @type {number}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    callbackRate?: number;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    workingType?: PlaceMultipleOrdersBatchOrdersParameterInnerWorkingTypeEnum;
    /**
     * Used with `STOP/STOP_MARKET` or `TAKE_PROFIT/TAKE_PROFIT_MARKET` orders.
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    priceProtect?: PlaceMultipleOrdersBatchOrdersParameterInnerPriceProtectEnum;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    newOrderRespType?: PlaceMultipleOrdersBatchOrdersParameterInnerNewOrderRespTypeEnum;
    /**
     * only avaliable for `LIMIT`/`STOP`/`TAKE_PROFIT` order; can\'t be passed together with `price`
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    priceMatch?: PlaceMultipleOrdersBatchOrdersParameterInnerPriceMatchEnum;
    /**
     * `EXPIRE_TAKER`:expire taker order when STP triggers/ `EXPIRE_MAKER`:expire taker order when STP triggers/ `EXPIRE_BOTH`:expire both orders when STP triggers
     * @type {string}
     * @memberof PlaceMultipleOrdersBatchOrdersParameterInner
     */
    selfTradePreventionMode?: PlaceMultipleOrdersBatchOrdersParameterInnerSelfTradePreventionModeEnum;
}

export const PlaceMultipleOrdersBatchOrdersParameterInnerSideEnum = {
    BUY: 'BUY',
    SELL: 'SELL',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerSideEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerSideEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerSideEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerPositionSideEnum = {
    BOTH: 'BOTH',
    LONG: 'LONG',
    SHORT: 'SHORT',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerPositionSideEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerPositionSideEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerPositionSideEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerTypeEnum = {
    LIMIT: 'LIMIT',
    MARKET: 'MARKET',
    STOP: 'STOP',
    STOP_MARKET: 'STOP_MARKET',
    TAKE_PROFIT: 'TAKE_PROFIT',
    TAKE_PROFIT_MARKET: 'TAKE_PROFIT_MARKET',
    TRAILING_STOP_MARKET: 'TRAILING_STOP_MARKET',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerTypeEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerTypeEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerTypeEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerTimeInForceEnum = {
    GTC: 'GTC',
    IOC: 'IOC',
    FOK: 'FOK',
    GTX: 'GTX',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerTimeInForceEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerTimeInForceEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerTimeInForceEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerReduceOnlyEnum = {
    TRUE: 'true',
    FALSE: 'false',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerReduceOnlyEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerReduceOnlyEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerReduceOnlyEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerWorkingTypeEnum = {
    MARK_PRICE: 'MARK_PRICE',
    CONTRACT_PRICE: 'CONTRACT_PRICE',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerWorkingTypeEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerWorkingTypeEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerWorkingTypeEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerPriceProtectEnum = {
    TRUE: 'true',
    FALSE: 'false',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerPriceProtectEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerPriceProtectEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerPriceProtectEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerNewOrderRespTypeEnum = {
    ACK: 'ACK',
    RESULT: 'RESULT',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerNewOrderRespTypeEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerNewOrderRespTypeEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerNewOrderRespTypeEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerPriceMatchEnum = {
    OPPONENT: 'OPPONENT',
    OPPONENT_5: 'OPPONENT_5',
    OPPONENT_10: 'OPPONENT_10',
    OPPONENT_20: 'OPPONENT_20',
    QUEUE: 'QUEUE',
    QUEUE_5: 'QUEUE_5',
    QUEUE_10: 'QUEUE_10',
    QUEUE_20: 'QUEUE_20',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerPriceMatchEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerPriceMatchEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerPriceMatchEnum];
export const PlaceMultipleOrdersBatchOrdersParameterInnerSelfTradePreventionModeEnum = {
    EXPIRE_TAKER: 'EXPIRE_TAKER',
    EXPIRE_MAKER: 'EXPIRE_MAKER',
    EXPIRE_BOTH: 'EXPIRE_BOTH',
} as const;

export type PlaceMultipleOrdersBatchOrdersParameterInnerSelfTradePreventionModeEnum =
    (typeof PlaceMultipleOrdersBatchOrdersParameterInnerSelfTradePreventionModeEnum)[keyof typeof PlaceMultipleOrdersBatchOrdersParameterInnerSelfTradePreventionModeEnum];
